import { ReactNode } from 'react';

import { ConfigGuard } from '@occc-app/App/guards';

type RetailerNetworkTobaccoPerformanceGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkTobaccoPerformanceGuard = ({
  children,
}: RetailerNetworkTobaccoPerformanceGuardProps) => {
  return (
    <ConfigGuard isFeatureEnabled={(config) => config.retailerConnectTobaccoPerformance.enabled}>
      {children}
    </ConfigGuard>
  );
};
